import { connect } from 'react-redux'
import { showModal } from 'redux/modules/modals'
import PricingsComponent from '../components/PricingsComponent'

const mapActionCreators = {
  showModal
}

const mapStateToProps = state => {
  return {
    tableTypes: state.settings.tableTypes,
    pricings: state.pricings.list
  }
}

export default connect(mapStateToProps, mapActionCreators)(PricingsComponent)



// WEBPACK FOOTER //
// ./src/routes/Admin/Pricings/containers/AdminPricingsContainer.js